import {SessionSiteSelectors} from '~selectors/SessionInfoSelectors';
import { getAppStore } from '~src/app/AppStore';

import { Messages } from '../../codegen/Localize';
import { IErrorDetail } from '../../commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { CommonErrorCode, MetricErrorCode, TagErrorCode } from '../../ts/helpers/ErrorCodes';
import { ContentUrlForItem } from '../../ts/services/ContentUrl';
import { IMetricInfo } from '../models/IMetricInfo';
import { MetricContentType } from '../models/MetricContentType';
export namespace MetricErrors {

  export function errorDetailsFor(metricErrorItem: IErrorItem<IMetricInfo>): IErrorDetail {
    return {
      itemName: metricErrorItem.item.name,
      itemUrl:
          metricErrorItem.error.code === MetricErrorCode.MetricNotFound
          ? null
          : ContentUrlForItem(metricErrorItem.item, MetricContentType),
      errorMessage: this.errorMessageFor(metricErrorItem)
    };
  }

  export function errorMessageFor(errorItem: IErrorItem<IMetricInfo>) {
    const metric = errorItem.item;
    switch (errorItem.error.code) {
      case MetricErrorCode.MetricNotFound:
        return Messages.errorMetricNotFound({METRIC_NAME: metric.name});
      case MetricErrorCode.MetricNameAlreadyExistsInDestinationProject:
        return Messages.errorMetricNameAlreadyExistsInDestinationProject();
      case TagErrorCode.TooManyTags:
        return Messages.changeTagsErrorTooManyTags({TAG_LIMIT: SessionSiteSelectors.tagLimit(getAppStore().getState())+''});
      // Permissions errors
      case MetricErrorCode.MetricMoveInsufficientPermissionsOnMetric:
        return Messages.errorMetricMoveInsufficientPermissions();
      case CommonErrorCode.CallingUserInsufficientPermissions:
        return Messages.errorMetricInsufficientPermissions();

      default:
        return Messages.errorUnknown();
    }
  }
}
